(() => {
  const root = document.getElementById('kf-showcase');
  const products = Array.isArray(window.KF_CATALOG) ? window.KF_CATALOG : [];
  if (!root) return;

  const $ = (id) => root.querySelector(`#${id}`);
  const byId = new Map(products.map((product) => [product.id, product]));
  const storageKey = 'kf-showcase-shortlist-v1';
  const labels = {
    wudu_basin: 'Wudu Basin', countertop: 'Countertop', pedestal: 'Pedestal', undermount: 'Undermount',
    wall_hung: 'Wall hung', inset: 'Drop-in', semi_recessed: 'Semi-recessed',
    rectangular: 'Rectangular', square: 'Square', oval: 'Oval', round: 'Round',
    corner: 'Corner', irregular: 'Irregular', semi_round: 'Semi-round', none: 'No tap hole', one: 'One tap hole',
    two: 'Two tap holes', yes: 'Yes', no: 'No', unknown: 'To be confirmed'
  };
  const display = (value) => labels[value] || (value ? String(value).replaceAll('_', ' ') : 'To be confirmed');
  const size = (product) => {
    const values = [product.width_mm, product.depth_mm, product.height_mm].map(v => Number.isFinite(Number(v)) && Number(v) > 0 ? Number(v) : null);
    return values.some(v => v !== null) ? `${values.map(v => v ?? '—').join(' × ')} mm` : 'Size to be confirmed';
  };
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  let saved = new Set();
  try {
    const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(value)) saved = new Set(value.filter((id) => byId.has(id)));
  } catch (_) { /* Private browsing may block storage. */ }
  const projectColoursKey = 'kf-project-colours-v1';
  let projectColours = {};
  try { projectColours = window.KFProject.readColours(localStorage.getItem(projectColoursKey), [...saved]); } catch (_) {}
  let matches = [];
  let lastResult = null;
  let lastFocus = null;

  const persist = () => {
    try { localStorage.setItem(storageKey, JSON.stringify([...saved])); } catch (_) { /* The in-page list still works. */ }
    $('kf-shortlist-count').textContent = String(saved.size);
    $('kf-project-count').textContent = String(saved.size);
    root.querySelectorAll('.kf-save').forEach((button) => {
      const active = saved.has(button.dataset.id);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Save'} ${byId.get(button.dataset.id)?.model || 'model'} ${active ? 'from' : 'to'} my project`);
      button.textContent = active ? 'Saved' : 'Save';
    });
    renderProject();
  };

  function toggleSave(id) {
    if (saved.has(id)) { saved.delete(id); delete projectColours[id]; saveProjectColours(); }
    else saved.add(id);
    persist();
  }

  function card(match) {
    const product = match.product;
    const article = el('article', 'kf-card');
    article.dataset.productId = product.id;
    const imageButton = el('button', 'kf-card-image');
    imageButton.type = 'button';
    imageButton.setAttribute('aria-label', `View details for ${product.model}`);
    const image = el('img');
    image.src = product.image;
    image.alt = `${product.model} ceramic basin`;
    image.loading = 'lazy';
    image.decoding = 'async';
    imageButton.append(image);
    const badge = el('span', 'kf-card-badge', display(product.shape));
    imageButton.append(badge);
    imageButton.addEventListener('click', () => openDetail(product));
    const text = el('div', 'kf-card-text');
    const description = el('div', 'kf-card-description');
    description.append(el('div', 'kf-card-model', product.model), el('div', 'kf-card-sub', size(product)));
    const saveButton = el('button', 'kf-save');
    saveButton.type = 'button';
    saveButton.dataset.id = product.id;
    saveButton.addEventListener('click', () => toggleSave(product.id));
    const differences = Object.entries(match.differences).map(([key, value]) => `${dimensionLabels[key]} ${value === null ? 'unconfirmed' : value === 0 ? 'exact' : `${value > 0 ? '+' : ''}${value} mm`}`);
    if (differences.length) description.append(el('p', 'kf-card-difference', differences.join(' · ')));
    text.append(description, saveButton);
    article.append(imageButton, text);
    return article;
  }

  const dimensionLabels = {width_mm:'Width', depth_mm:'Depth', height_mm:'Height'};
  const fieldLabels = {category:'Basin type',mounting_type:'Installation', shape:'Shape', tap_hole:'Tap holes', overflow:'Overflow'};

  const rangeGroups = [...root.querySelectorAll('.kf-dimension-range')];
  function updateRange(group, changed) {
    const [lower, upper] = group.querySelectorAll('input');
    if (Number(lower.value) > Number(upper.value)) {
      if (changed === lower) lower.value = upper.value;
      else upper.value = lower.value;
    }
    group.querySelector('output').value = `${lower.value}–${upper.value} mm`;
    const span = Number(upper.max) - Number(lower.min);
    group.style.setProperty('--kf-range-min', `${(Number(lower.value)-Number(lower.min))/span*100}%`);
    group.style.setProperty('--kf-range-max', `${(Number(upper.value)-Number(lower.min))/span*100}%`);
    for (const input of [lower, upper]) input.setAttribute('aria-valuetext', `${input.value} mm`);
  }
  function selectedRanges() {
    const ranges = {};
    for (const group of rangeGroups) {
      const [lower, upper] = group.querySelectorAll('input');
      // Leaving both endpoints at their outer limits keeps this dimension unrestricted.
      if (lower.value !== lower.min || upper.value !== upper.max) {
        ranges[group.dataset.field] = {min:Number(lower.value), max:Number(upper.value)};
      }
    }
    return ranges;
  }
  for (const group of rangeGroups) {
    updateRange(group);
    for (const input of group.querySelectorAll('input')) {
      input.addEventListener('input', () => updateRange(group, input));
      input.addEventListener('focus', () => {
        for (const sibling of group.querySelectorAll('input')) sibling.style.zIndex = sibling === input ? '3' : '2';
      });
    }
  }
  $('kf-search-form').addEventListener('reset', () => queueMicrotask(() => rangeGroups.forEach(group => updateRange(group))));

  const stream = new window.KFResultStream($('kf-grid'), card, persist);
  function renderGrid() {
    stream.reset(matches);
    $('kf-results-title').firstChild.textContent = lastResult.provisionalFields?.length ? 'Possible basins ' : 'Matching basins ';
    $('kf-result-count').textContent = String(matches.length);
    const order = $('kf-result-sort').value;
    const orderCaption = order === 'height-asc' ? 'Height: low to high · unconfirmed heights last'
      : order === 'height-desc' ? 'Height: high to low · unconfirmed heights last'
      : Object.keys(lastResult.dimensions).length ? 'Closest width and depth first' : 'Matching your search';
    $('kf-result-caption').textContent = (lastResult.provisionalFields?.length ? 'Possible matches · selected hole details unverified. ' : '') + orderCaption;
    $('kf-empty').hidden = matches.length !== 0;
    persist();
  }

  const filterValue = id => [ '', 'all' ].includes($(id).value) ? '' : $(id).value;
  let searchInFlight = false;
  async function refreshCatalogue() {
    const url = new URL(location.href);
    url.searchParams.set('kf_current', String(Date.now()));
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {cache:'no-store', signal:controller.signal});
      if (!response.ok) throw new Error('Catalogue unavailable');
      const documentNow = new DOMParser().parseFromString(await response.text(), 'text/html');
      const script = [...documentNow.scripts].find(node => /window\.KF_CATALOG\s*=/.test(node.textContent));
      const match = script?.textContent.match(/window\.KF_CATALOG\s*=\s*(\[[\s\S]*?\])\s*;/);
      const current = match && JSON.parse(match[1].replace(/,\s*]$/, ']'));
      if (!Array.isArray(current) || !current.length || current.some(item => !item.id) || new Set(current.map(item=>item.id)).size !== current.length) throw new Error('Invalid catalogue');
      products.splice(0, products.length, ...current);
      byId.clear();
      current.forEach(product => byId.set(product.id, product));
      window.KF_CATALOG = products;
      root.dataset.catalogueVersion = documentNow.getElementById('kf-showcase')?.dataset.catalogueVersion || '';
    } finally {
      clearTimeout(timer);
    }
  }
  async function runSearch(event) {
    event.preventDefault();
    if (searchInFlight) return;
    searchInFlight = true;
    const submit = $('kf-search-form').querySelector('[type="submit"]');
    const wasDisabled = submit.disabled;
    submit.disabled = true;
    $('kf-results').hidden = true;
    stream.reset([]);
    $('kf-search-status').textContent = 'Checking the latest catalogue…';
    try {
      await refreshCatalogue();
    } catch (_) {
      $('kf-search-status').textContent = 'Could not load the latest catalogue. Please search again.';
      return;
    } finally {
      searchInFlight = false;
      submit.disabled = wasDisabled;
    }
    lastResult = window.KFSearch.search(products, {
      text:$('kf-search').value,
      filters:{category:filterValue('kf-mounting')==='wudu_basin'?'wudu_basin':'',mounting_type:filterValue('kf-mounting')==='wudu_basin'?'':filterValue('kf-mounting'),shape:filterValue('kf-shape'),tap_hole:$('kf-tap').value,overflow:$('kf-overflow').value},
      ranges:selectedRanges()
    });
    const summary=[];
    for (const [field, group] of Object.entries(lastResult.constraints)) {
      if (group.include.length) summary.push(fieldLabels[field]+': '+group.include.map(display).join(' or '));
      if (group.exclude.length) summary.push('Exclude '+group.exclude.map(display).join(', '));
    }
    for (const [key,value] of Object.entries(lastResult.dimensions)) summary.push(dimensionLabels[key]+': '+value+' mm');
    for (const [key,range] of Object.entries(lastResult.ranges)) summary.push(`${dimensionLabels[key]}: ${range.min}–${range.max} mm`);
    if (lastResult.modelTerms.length) summary.push('Model: '+lastResult.modelTerms.join(' '));
    $('kf-search-summary').textContent = summary.join(' · ');
    const warnings=[];
    if (lastResult.unresolved.length) warnings.push('Not searched: '+lastResult.unresolved.join(', ')+'. These words are not matched to confirmed catalogue details. Enter dimensions in the size fields.');
    if (lastResult.overrides.length) warnings.push('Your selected options were used for '+lastResult.overrides.map(field=>fieldLabels[field].toLowerCase()).join(', ')+'.');
    if (lastResult.provisionalFields?.length) warnings.push('No confirmed match for the selected '+lastResult.provisionalFields.map(field=>fieldLabels[field].toLowerCase()).join(' and ')+'. These are possible candidates with that detail unverified; check the product image before deciding.');
    $('kf-search-warning').textContent=warnings.join(' ');
    $('kf-search-warning').hidden=!warnings.length;
    matches=window.KFSearch.sortMatches(lastResult.items, $('kf-result-sort').value);
    const hasText=$('kf-search').value.trim().length>0;
    $('kf-results').hidden=!lastResult.active && !hasText;
    $('kf-search-status').textContent=lastResult.active ? matches.length+(lastResult.provisionalFields?.length ? ' possible models; hole details need checking. Results are below.' : ' matching models. Results are below.') : hasText ? 'No searchable details recognised. Try a model number or use the options below.' : 'Add a description, a dimension or a detail to search.';
    renderGrid();
    if (!$('kf-results').hidden) $('kf-results').scrollIntoView({block:'start',behavior:'smooth'});
  }

  function markEdited() {
    $('kf-results').hidden=true;
    stream.reset([]);
    $('kf-search-status').textContent=$('kf-mounting').value && $('kf-shape').value ? 'Search when you are ready to see matching basins.' : '';
  }
  function clearFilters() {
    $('kf-search-form').reset();
    $('kf-result-sort').value='best';
    markEdited();
    $('kf-search-status').textContent='';
    $('kf-mounting').focus();
  }

  function renderProject() {
    const list = $('kf-project-items');
    $('kf-enquire').disabled = !saved.size;
    $('kf-download').disabled = !saved.size;
    updateEnquiry();
    if (!saved.size) {
      $('kf-enquiry-fields').hidden = true;
      list.replaceChildren(el('p', 'kf-project-intro', 'No models saved yet. Search for a basin, then choose Save on a model card.'));
      return;
    }
    list.replaceChildren(...[...saved].map((id) => {
      const product = byId.get(id);
      const row = el('div', 'kf-project-item');
      const image = el('img');
      image.src = product.image;
      image.alt = '';
      image.loading = 'lazy';
      const description = el('div');
      description.append(el('strong', '', product.model), el('small', '', size(product)));
      const colourLabel = el('div', 'kf-project-colour');
      colourLabel.append(el('span', '', 'Colour preference'));
      const picker = el('details', 'kf-colour-picker');
      const summary = el('summary');
      const colourMenu = el('div', 'kf-colour-menu');
      colourMenu.setAttribute('role', 'group');
      colourMenu.setAttribute('aria-label', `Colour options for ${product.model}`);
      function swatch(value) {
        const badge = el('span', 'kf-colour-swatch');
        badge.setAttribute('aria-hidden', 'true');
        badge.style.background = window.KFProject.colourPaint(value);
        return badge;
      }
      function updateColour() {
        const value = projectColours[id] || 'pictured';
        summary.replaceChildren(swatch(value), el('span', '', window.KFProject.colourLabel(value)), el('span', 'kf-colour-chevron', '⌄'));
        summary.setAttribute('aria-label', `Colour for ${product.model}: ${window.KFProject.colourLabel(value)}`);
        colourMenu.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colour === value)));
      }
      for (const [value, label] of window.KFProject.colours) {
        const option = el('button', 'kf-colour-option');
        option.type = 'button';
        option.dataset.colour = value;
        option.append(swatch(value), el('span', '', label));
        option.addEventListener('click', () => {
          projectColours[id] = value;
          saveProjectColours();
          updateEnquiry();
          updateColour();
          picker.open = false;
          summary.focus();
        });
        colourMenu.append(option);
      }
      updateColour();
      picker.append(summary, colourMenu, el('p', 'kf-colour-note', 'Colour guide only; final finish to be confirmed.'));
      picker.addEventListener('toggle', () => {
        if (picker.open) root.querySelectorAll('.kf-colour-picker[open]').forEach(other => { if (other !== picker) other.open = false; });
      });
      colourLabel.append(picker);
      description.append(colourLabel);
      const remove = el('button', '', 'Remove');
      remove.type = 'button';
      remove.setAttribute('aria-label', `Remove ${product.model}`);
      remove.addEventListener('click', () => toggleSave(id));
      row.append(image, description, remove);
      return row;
    }));
  }

  let priorOverflow = '';
  function setPanel(open) {
    const panel=$('kf-project');
    if (open && !panel.classList.contains('kf-open')) priorOverflow=document.body.style.overflow;
    panel.classList.toggle('kf-open',open);
    panel.setAttribute('aria-hidden',String(!open));
    $('kf-scrim').hidden=!open;
    document.body.style.overflow=open?'hidden':priorOverflow;
    if (!open && lastFocus) lastFocus.focus();
  }

  function openDetail(product) {
    const detail = $('kf-detail');
    const picture = el('div', 'kf-detail-picture');
    const image = el('img');
    image.src = product.image;
    image.alt = `${product.model} ceramic basin`;
    picture.append(image);
    const info = el('div', 'kf-detail-info');
    info.append(el('p', 'kf-results-kicker', 'Kangfan basins'), el('h2', '', product.model));
    const list = el('dl');
    [['Dimensions', size(product)], ['Basin type', display(product.category === 'wudu_basin' ? product.category : product.mounting_type)], ['Shape', display(product.shape)], ['Tap hole', display(product.tap_hole)], ['Overflow', display(product.overflow)]].forEach(([name, value]) => {
      const group = el('div');
      group.append(el('dt', '', name), el('dd', '', value));
      list.append(group);
    });
    info.append(list);
    const saveButton = el('button', '', saved.has(product.id) ? 'Remove from my project' : 'Add to my project');
    saveButton.type = 'button';
    saveButton.addEventListener('click', () => {
      toggleSave(product.id);
      saveButton.textContent = saved.has(product.id) ? 'Remove from my project' : 'Add to my project';
    });
    info.append(saveButton, el('p', 'kf-detail-note', 'Specifications are being checked. Please confirm final details when requesting a quote.'));
    const layout = el('div', 'kf-detail-layout');
    layout.append(picture, info);
    $('kf-detail-content').replaceChildren(layout);
    lastFocus = document.activeElement;
    if (typeof detail.showModal === 'function') detail.showModal();
  }

  function selectionText() {
    return window.KFProject.selectionText([...saved].map(id => byId.get(id)), projectColours, size);
  }

  function saveProjectColours() {
    try { localStorage.setItem(projectColoursKey, JSON.stringify(projectColours)); } catch (_) {}
  }

  function updateEnquiry() {
    $('kf-enquiry-selection').value = selectionText();
    $('kf-enquiry-count').textContent = `${saved.size} selected ${saved.size === 1 ? 'basin' : 'basins'}, including your colour preferences, will be sent with your message.`;
    $('kf-enquiry-send').disabled = !saved.size;
  }

  function csvCell(value) { return `"${String(value ?? '').replaceAll('"', '""')}"`; }

  $('kf-search-form').addEventListener('submit',runSearch);
  $('kf-search-form').addEventListener('input',markEdited);
  $('kf-search-form').addEventListener('change',markEdited);
  $('kf-result-sort').addEventListener('change', () => {
    if (!lastResult) return;
    matches=window.KFSearch.sortMatches(lastResult.items, $('kf-result-sort').value);
    renderGrid();
  });
  $('kf-clear').addEventListener('click',clearFilters);
  $('kf-empty-clear').addEventListener('click',clearFilters);
  $('kf-shortlist-toggle').addEventListener('click',()=>{lastFocus=document.activeElement;setPanel(true);$('kf-project-close').focus();});
  $('kf-project-close').addEventListener('click',()=>setPanel(false));
  $('kf-scrim').addEventListener('click',()=>setPanel(false));
  $('kf-detail-close').addEventListener('click',()=>$('kf-detail').close());
  $('kf-detail').addEventListener('close',()=>{if(lastFocus)lastFocus.focus();});
  document.addEventListener('keydown',(event)=>{
    if(event.key!=='Escape')return;
    const picker=root.querySelector('.kf-colour-picker[open]');
    if(picker){picker.open=false;picker.querySelector('summary').focus();return;}
    if($('kf-project').classList.contains('kf-open'))setPanel(false);
  });
  document.addEventListener('click',event=>{
    root.querySelectorAll('.kf-colour-picker[open]').forEach(picker=>{if(!picker.contains(event.target))picker.open=false;});
  });
  $('kf-enquire').addEventListener('click', () => {
    if (!saved.size) { $('kf-action-status').textContent = 'Save a model first.'; return; }
    updateEnquiry();
    $('kf-enquiry-fields').hidden = false;
    $('kf-enquiry-name').focus();
  });
  $('kf-enquiry-form').addEventListener('submit', updateEnquiry);
  $('kf-download').addEventListener('click', () => {
    if (!saved.size) { $('kf-action-status').textContent = 'Save a model first.'; return; }
    const rows = [['Model', 'Width mm', 'Depth mm', 'Height mm', 'Installation', 'Shape', 'Tap hole', 'Overflow', 'Requested colour']];
    [...saved].forEach((id) => {
      const p = byId.get(id);
      rows.push([p.model, p.width_mm, p.depth_mm, p.height_mm, display(p.mounting_type), display(p.shape), display(p.tap_hole), display(p.overflow), window.KFProject.colourLabel(projectColours[id])]);
    });
    const csv = '\uFEFF' + rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const anchor = el('a');
    anchor.href = url;
    anchor.download = 'kangfan-basin-selection.csv';
    anchor.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    $('kf-action-status').textContent = 'CSV downloaded.';
  });

  const handle=$('kf-resize-handle');
  const options=$('kf-search-options');
  const resize = (value) => {
    const percent=Math.max(42,Math.min(65,value));
    options.style.setProperty('--kf-dimension-share',percent+'%');
    handle.setAttribute('aria-valuenow',String(Math.round(percent)));
  };
  handle.addEventListener('pointerdown',(event)=>{
    if(matchMedia('(max-width:800px)').matches)return;
    event.preventDefault();handle.setPointerCapture(event.pointerId);
    const move=(e)=>{const box=options.getBoundingClientRect();resize((e.clientX-box.left)/box.width*100);};
    const stop=()=>{handle.removeEventListener('pointermove',move);handle.removeEventListener('pointerup',stop);handle.removeEventListener('pointercancel',stop);};
    handle.addEventListener('pointermove',move);handle.addEventListener('pointerup',stop);handle.addEventListener('pointercancel',stop);
  });
  handle.addEventListener('keydown',(event)=>{
    if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();resize(Number(handle.getAttribute('aria-valuenow'))+(event.key==='ArrowRight'?2:-2));
  });
  persist();
  const enquiryResult = $('kf-enquiry-result');
  if (enquiryResult) {
    setPanel(true);
    if (enquiryResult.dataset.result === 'error') $('kf-enquiry-fields').hidden = false;
    enquiryResult.focus();
  }
})();
